/**
 * Runtime config injected by the Cloudflare Worker into every HTML response
 * (`window.__EDGE_RUNTIME_CONFIG__`). Ensures Clerk + Cloudinary client vars
 * work in Plan B even when the CF Pages mirror was built without full VITE_* env.
 */

export type EdgeRuntimeConfig = {
  brandSourceKey?: string;
  clerkPublishableKey?: string;
  stripePublishableKey?: string;
  cloudinaryCloudName?: string;
  cloudinaryUploadPreset?: string;
  cloudinaryBaseFolder?: string;
  cloudinaryWatermarkId?: string;
  posthogKey?: string;
  posthogHost?: string;
  ddRumApplicationId?: string;
  ddRumClientToken?: string;
  ddRumSampleRate?: string;
  premiumMuxEsVip?: string;
  premiumMuxEnVip?: string;
  muxCtaUniversalPlaybackId?: string;
  telegramGroupsPlaybackId?: string;
  telegramGroupsFallbackPlaybackId?: string;
  mpCheckoutBasicAr?: string;
  mpCheckoutVipAr?: string;
  mpCheckoutVipDiscountAr?: string;
};

declare global {
  interface Window {
    __EDGE_RUNTIME_CONFIG__?: EdgeRuntimeConfig;
  }
}

export function getEdgeRuntimeConfig(): EdgeRuntimeConfig | null {
  if (typeof window === "undefined") return null;
  const cfg = window.__EDGE_RUNTIME_CONFIG__;
  return cfg && typeof cfg === "object" ? cfg : null;
}

export function edgeRuntimeString(
  key: keyof EdgeRuntimeConfig,
): string | undefined {
  const v = getEdgeRuntimeConfig()?.[key];
  return typeof v === "string" && v.trim().length > 0 ? v.trim() : undefined;
}